import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaymentForm from './StripePaymentForm';

const PaymentModal = ({ isOpen, onClose, onPaymentSuccess, onPaymentError, loading, disabled, title = "Complete Payment", description = "Please complete your payment to continue." }) => {
  const [stripePromise, setStripePromise] = useState(null);

  // Initialize Stripe
  React.useEffect(() => {
    const initStripe = async () => {
      const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
      setStripePromise(stripe);
    };
    initStripe();
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-gray-900">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h3 className="font-medium text-blue-900 mb-2">Subscription Details</h3>
            <div className="text-sm text-blue-700 space-y-1">
              <div><span className="font-medium">Plan:</span> Shift Healthcare Pro</div>
              <div><span className="font-medium">Price:</span> $80/month</div>
              <div><span className="font-medium">Billing:</span> Monthly</div>
            </div>
          </div>

          <p className="text-gray-600 mb-4">{description}</p>

          {stripePromise && (
            <Elements stripe={stripePromise}>
              <StripePaymentForm
                onPaymentSuccess={onPaymentSuccess}
                onPaymentError={onPaymentError}
                loading={loading}
                disabled={disabled}
              />
            </Elements>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
